import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Media } from '../../theme/Media.js';
const Wrapper = styled.div `
  @media ${Media.smMin} {
    flex: 0 0 290px;
  }
  position: relative;
`;
const Search = ({ children, dataTestId }) => _jsx(Wrapper, { "data-testid": dataTestId, children: children });
export default Search;
